import { render } from "./MonkView.vue?vue&type=template&id=cc90be14&scoped=true"
import script from "./MonkView.vue?vue&type=script&lang=js"
export * from "./MonkView.vue?vue&type=script&lang=js"

import "./MonkView.vue?vue&type=style&index=0&id=cc90be14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc90be14"]])

export default __exports__